import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk-widget-settings.content.preview-wrapper.title',
		defaultMessage: 'Preview',
		description:
			'Title for the preview wrapper, displayed above the preview of the widget which changes as the user changes the settings',
	},
});
